import { styled, Typography } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const IconWrap = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: theme.typography.pxToRem(80),
  justifyContent: 'center',
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(11),
  },
}));

export const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  fontSize: theme.typography.pxToRem(25),
  justifyContent: 'center',
  lineHeight: theme.typography.pxToRem(20),
  margin: theme.spacing(4, 0),
}));

export const TextInfo = styled('p')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: theme.typography.pxToRem(19),
  margin: 0,
  paddingBottom: theme.spacing(1),
  textAlign: 'center',
}));
